import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Heading from 'shopper/components/Heading';

const CookiesHeading = ({ className }) => (
  <div
    className={twMerge(
      "h-24 bg-primary-300 bg-[url(/dist/images/features/cookies/cookies-bg-mobile.svg)] bg-cover bg-right bg-no-repeat md:h-[184px] md:bg-[url('/dist/images/features/cookies/cookies-bg-desktop.svg')]",
      className
    )}
  >
    <div className="relative mx-auto my-0 flex size-full items-center px-3 md:px-2 lg:w-screen-lg xl:w-screen-xl">
      <Heading as="h1" className="text-neutral-high-100" size="size2">
        Política de Cookies
      </Heading>
    </div>
  </div>
);

CookiesHeading.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default CookiesHeading;
